<template>
  <v-snackbar
    v-model="snackbar"
    :bottom="true"
    :left="true"
    :multi-line="true"
    :timeout="3000"
    :vertical="false"
  >
    {{ snackbarMsg }}
    <v-btn color="pink" flat @click="snackbar = false">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
import EventBus from '@/event_bus'

export default {
  name: 'GlobalNotifications',
  data: function() {
    return {
      snackbar: false,
      snackbarMsg: ''
    }
  },
  mounted() {
    const vm = this
    // Network errors are displayed in global scope.
    EventBus.$on('REQUEST_ERROR', payload => {
      console.log(payload)
      vm.snackbar = true
      vm.snackbarMsg = 'There was a problem connecting to the server'
    })
    EventBus.$on('RESPONSE_ERROR', payload => {
      console.log(payload)
      vm.snackbar = true
      vm.snackbarMsg = 'Request failed. Please try again'
    })
    EventBus.$on('SHOW_SNACK', payload => {
      console.log(payload)
      vm.snackbar = true
      vm.snackbarMsg = payload.msg
    })
  }
}
</script>

<style scoped></style>
